import React, { ReactElement } from 'react'

import DisplaySwitching from './DisplaySwitching'

// CSS imports. Commented out because of current build process.
// import './settingsTab.scss'

/**
 * Component properties type.
 */
type Props = {
    includeInTransitioningSequence: boolean
    setIncludeInTransitioningSequence: (checked: boolean) => void
    rptDisplIntervalTime: string
    setRptDisplIntervalTime: (newValue: string) => void
}

/**
 * Settings tab of report configuration modal window.
 *
 * @param includeInTransitioningSequence
 * @param setIncludeInTransitioningSequence
 * @param rptDisplIntervalTime
 * @param setRptDisplIntervalTime
 */
const SettingsTab: React.FC<Props> = ({
    includeInTransitioningSequence,
    setIncludeInTransitioningSequence,
    rptDisplIntervalTime,
    setRptDisplIntervalTime
}: Props): ReactElement => (
    <div className='settings-tab tab-area'>
        <DisplaySwitching
            includeInTransitioningSequence={includeInTransitioningSequence}
            setIncludeInTransitioningSequence={setIncludeInTransitioningSequence}
            rptDisplIntervalTime={rptDisplIntervalTime}
            setRptDisplIntervalTime={setRptDisplIntervalTime}
        />
    </div>
)

export default SettingsTab
